import BaseFactory from 'services/sports/default/base-factory';
import LP from './lp';

class Factory extends BaseFactory {
    createObj(objectName, params) {
        return new LP(params);
    }
}

export {Factory};
